module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/todo.994300b0.svg";